<script>
  export default {
    name: 'base-crud',
    data () {
      return {
        basePermission: ''
      }
    },
    methods: {
      // Default Functions to check permissions
      can (permission) {
        return this.$auth.hasAllPermissions() ||
          this.$store.state.permissions.some(item => item === permission)
      },
      canShow () {
        return this.can(this.basePermission + '_s')
      },
      canAdd () {
        return this.can(this.basePermission + '_a')
      },
      canUpdate () {
        return this.can(this.basePermission + '_u')
      },
      canDelete () {
        return this.can(this.basePermission + '_x')
      },
      canEditToSave () {
        return (this.form.id && !this.canUpdate()) ||
          (!this.form.id && !this.canAdd())
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/abstract/Permissions.vue